import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { CreateExpenseCard } from './CreateExpenseCard'; // Import the new component
import Box from '@mui/material/Box';

export const GroupScreen = () => {
    const { groupId } = useParams();
    const navigate = useNavigate();

    return (
        <Box sx={{ padding: 2 }}> {/* Box for layout and padding */}
            <div>THIS IS A GROUP SCREEN FOR {groupId}</div>
            <CreateExpenseCard onClick={() => navigate(`/groups/${groupId}/new`)} />
        </Box>
    );
};
